import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'
import FeaturedTable from '../../FeaturedTable/FeaturedTable'
import PaginationFooter from '../../PaginationFooter/PaginationFooter'
import { getInvoicesWithCount } from '../../../reducers/chatReducer'

import { chatInvoicesTableColumns } from './utils'

const InvoicesFullView = ({ invoices, timezone, buildingId, getInvoicesWithCount, onClose }) => {
  const { t } = useTranslation(['chat'])
  const [showOnPage, setShowOnPage] = useState(25)
  const [pageNumber, setPageNumber] = useState(1)
  const [paginationItemsCount, setPaginationItemsCount] = useState(0)

  const handleActionInvoice = (paymentMethod, pdfUrl) => {
    if (paymentMethod === 'Invoice') {
      const recipientEmail = 'contact@elevatedliving.com '
      const subject = t('chat:invoicesFullView.invoicePaymentSubject')
      const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}`
      window.location.assign(mailtoLink)
    } else {
      window.open(pdfUrl, '_blank')
    }
  }

  const fetchInvoices = async (skip = 1, buildingId) => {
    try {
      await getInvoicesWithCount(skip, buildingId, showOnPage).then((count) =>
        setPaginationItemsCount(count),
      )
    } catch (err) {
      throw new Error(err)
    }
  }

  useEffect(() => {
    if (buildingId) {
      fetchInvoices(pageNumber, buildingId)
    }
  }, [pageNumber])

  return (
    <div className="invoices-view">
      <div className="navigation-container" onClick={onClose}>
        <Icon icon="arrow" />
        <span>{t('chat:selectedInboxDetails.back')}</span>
      </div>
      <div className="invoices-view__navbar">
        <div className="left-side">
          <div className="name">
            <div>{t('chat:invoicesFullView.invoices')}</div>
          </div>
        </div>
      </div>
      <div className="invoices-view__body">
        <FeaturedTable
          columns={chatInvoicesTableColumns(timezone, handleActionInvoice)}
          data={invoices}
        />
        {invoices && invoices.length ? (
          <PaginationFooter
            showOnPage={showOnPage}
            pageNumber={pageNumber}
            paginationItemsCount={paginationItemsCount}
            setSiteLoading={() => null}
            setShowOnPage={setShowOnPage}
            setPageNumber={setPageNumber}
          />
        ) : null}
      </div>
    </div>
  )
}

InvoicesFullView.propTypes = {
  invoices: PropTypes.array,
  timezone: PropTypes.string,
  buildingId: PropTypes.number,
  onClose: PropTypes.func,
  getInvoicesWithCount: PropTypes.func,
}

export default connect(null, {
  getInvoicesWithCount,
})(InvoicesFullView)
